import { render, staticRenderFns } from "./userMsgInfo.vue?vue&type=template&id=4020e5ab&"
import script from "./userMsgInfo.vue?vue&type=script&lang=js&"
export * from "./userMsgInfo.vue?vue&type=script&lang=js&"
import style0 from "./userMsgInfo.vue?vue&type=style&index=0&id=4020e5ab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports